import React from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { truncateString } from '../../../../services/helpers'
import {getFromS3, updateImportCsvRecord} from "../../../../services/backendApi";
import { useDropZoneState, useDropZoneDispatch } from '../../../contexts/drop-zone-context'
import { StatusMap } from '../../../../enum/ImportZones'
import Spinner from '../../../presentation/spinner'
import './style.css'
import {S3_BUCKETS} from "../../../../backendServices/s3";

const useStyles = makeStyles(() => ({
    customWidth: {
      maxWidth: 200,
    },
}));

const RecentImportsTable = ({ deleteFile, accountId }) => {
    const { filesList } = useDropZoneState()
    const { requiresFilesUpdate } = useDropZoneDispatch()
    const classes = useStyles()

    const createZones = async (fileId) => {
        try {
            // Triggers lambda function to create the Zones by updating the record status to "APPROVED"
            // This Create Zones lambda belongs to the `canvas_import_csv` service
            await updateImportCsvRecord(fileId, accountId, StatusMap.APPROVED.status)
            requiresFilesUpdate()
        } catch (error) {
            console.error('error', error)
            alert('There was an issue updating File status to create the Zones')
        }
    }

    const renderStatusCell = (file) => {
        if (file.status === StatusMap.FAILED.status) {
        const TooltipMessage = () => <span className="tooltip-message">{file.message}</span>

            return (
                <td style={{ color: StatusMap.FAILED.color }}>
                    <Tooltip title={<TooltipMessage />} placement="top" classes={{ tooltip: classes.customWidth }}>
                        <div className="center-cell-content">
                            <span>{ StatusMap.FAILED.message }</span>
                            <HelpOutlineIcon style={{ fontSize: 15 }}/>
                        </div>
                    </Tooltip>
                </td>
            )
        }

        return <td style={{ color: StatusMap[file.status].color }}>{ StatusMap[file.status].message }</td>
    }

    const renderCreateZonesButton = (file) => {
        if (file.status === StatusMap.PENDING_APPROVAL.status) {
            return (
                <Button 
                    variant="outlined" 
                    color="primary"
                    onClick={() => createZones(file.id)}
                >
                    Create Zones
                </Button>
            )
        }

        if (file.status === StatusMap.PROCESSING.status || file.status === StatusMap.APPROVED.status) {
            return <Spinner />
        }
    }

    const arrangeFilesData = (filesList) => {
        const arrengedData = filesList
            .filter(({ status }) => status !== StatusMap.COMPLETED.status)
            .sort((a, b) => (new Date(b.date)) - (new Date(a.date)))
        
        return arrengedData
    }

    return (
        <table className="files-list-table">
            <thead>
                <tr>
                    <th className="row-date"><h5>Date</h5></th>
                    <th className="row-name"><h5>File Name</h5></th>
                    <th className="row-status"><h5>Status</h5></th>
                    <th className="row-zones-imported"><h5>Zones Imported</h5></th>
                    <th className="row-download"><h5>Download</h5></th>
                    <th className="row-create-zones"></th>
                    <th className="row-delete-file"></th>
                </tr>
            </thead>
            <tbody>
                {   // Render only files that area not with status COMPLETED
                    arrangeFilesData(filesList).map(file => {
                        console.log(file)
                        return (<tr key={file.id}>
                            <td>{ moment(file.date).format('MMM DD, YYYY HH:mm') }</td>
                            <td>{ truncateString(file.fileName, 60) }</td>
                            { 
                                renderStatusCell(file) 
                            } 
                            <td>{ file.numberOfZones }</td>
                            <td><Button><a onClick={() => getFromS3(S3_BUCKETS.IMPORT_CSV, file.fileName)} className="pointer-cursor"><ArrowDownwardIcon color="primary"/></a></Button></td>
                            <td className="center-cell-content">
                                {  
                                  renderCreateZonesButton(file)
                                }
                            </td>
                            <td ><Button onClick={() => deleteFile(file.id)}><CloseIcon /></Button></td>
                        </tr>)
                    })
                }
            </tbody>
        </table>
    )
}

export default RecentImportsTable